import { useEffect, useLayoutEffect, useRef, useState } from "react";
import "./SiteBanner.scss";
import { CloseOutlined } from "@ant-design/icons";
import { isDSAPath, isLandingPath, setSiteBannerCookie } from "../util/utils";
import { useLocation } from "react-router-dom";
import TextBlockApi from "../api/TextBlockApi";

// Set to true to show banner
// const bannerOn = false;

// Mode can be "top", "bottom", or "banner"
const bannerMode = "top";

enum VisibleMode {
  Visible,
  Hidden,
}

export interface Props {
  setIsSiteBanner: any;
}

function extractTextColor(html: string): string {
  const match = html.match(/[;"\s]color:\s*(#[0-9a-fA-F]{3,8})/);
  return match ? match[1] : "#333333";
}

function updateBannerHeightVar(el: HTMLDivElement | null) {
  const h = el ? el.offsetHeight : 0;
  document.documentElement.style.setProperty('--site-banner-height', h + 'px');
}

export function SiteBanner({ setIsSiteBanner }: Props) {
  const loc = useLocation();
  const bannerRef = useRef<HTMLDivElement>(null);
  const [showBanner, setShowBanner] = useState(false);
  const [mode] = useState(VisibleMode.Visible);
  const [content, setContent] = useState("");
  const [closeColor, setCloseColor] = useState("#333333");

  useLayoutEffect(() => {
    const el = bannerRef.current;
    if (!el) {
      updateBannerHeightVar(null);
      return;
    }
    updateBannerHeightVar(el);
    const observer = new ResizeObserver(() => updateBannerHeightVar(el));
    observer.observe(el);
    return () => observer.disconnect();
  }, [showBanner, content]);

  const isDsa = isDSAPath(loc.pathname);

  useEffect(() => {
    const textBlockName = isDsa ? "Display Manager Notice" : "Dashboard Notice";
    TextBlockApi.getByName(textBlockName).then((resp) => {
      if (resp.data && resp.data.details) {
        setShowBanner(true);
        setIsSiteBanner(true);
        setContent(resp.data.details);
        setCloseColor(extractTextColor(resp.data.details));
      } else {
        setShowBanner(false);
        setIsSiteBanner(false);
      }
    })
  }, [isDsa, setIsSiteBanner]);

  // useEffect(() => {
  //   const textBlockName = isDSAPath(loc.pathname) ? "Display Manager Notice" : "Dashboard Notice";
  //   TextBlockApi.getByName(textBlockName).then((resp) => {
  //     if (resp.data && resp.data.details) {
  //       // setShowBanner(getCookie("showSiteBanner") !== "false")
  //       setContent(resp.data.details);
  //     }
  //   })
  // }, []);

  function onClose(ev: any) {
    ev.stopPropagation();
    setShowBanner(false);
    setSiteBannerCookie(false);
    console.log(setIsSiteBanner)
    setIsSiteBanner(false);
  }

  return (
    mode === VisibleMode.Hidden ? null : <>
      {showBanner && <div ref={bannerRef} className={`header-promo-banner ${bannerMode} ${isDSAPath(loc.pathname) ? 'dsa-notice' : ''}`}>
        <div className="banner-content" dangerouslySetInnerHTML={{ __html: content }}></div>
        <div className="close-btn" onClick={(ev) => onClose(ev)} style={{ display: isLandingPath(loc.pathname) ? "none" : "block", color: closeColor }}><CloseOutlined /></div>
      </div>}
    </>);
}
